import ACTIONS from "store/actionTypes";

export const loginRequest = (password, email, history) => ({
  type: ACTIONS.LOGIN_REQUEST,
  password,
  email,
  history,
});

export const loginSuccess = ({
  account,
  token,
  authenticated,
  permissions,
}) => ({
  type: ACTIONS.LOGIN_SUCCESS,
  authData: {
    account,
    permissions,
    token,
    authenticated,
  },
});

export const loginFail = ({ exception }) => ({
  type: ACTIONS.LOGIN_FAILURE,
  exception,
});

export const logout = () => ({
  type: ACTIONS.LOGOUT,
});

export const updateInfo = (data) => ({
  type: ACTIONS.UPDATE_INFO,
  data,
});

export const resetPasswordRequest = (email, history) => ({
  type: ACTIONS.RESET_PASSWORD_REQUEST,
  email,
  history,
});

export const resetPasswordSuccess = () => ({
  type: ACTIONS.RESET_PASSWORD_SUCCESS,
});

export const resetPasswordFail = (error) => ({
  type: ACTIONS.RESET_PASSWORD_FAILURE,
  error,
});
